import api from './axios';

export const checkVersion = async () => {
  try {
    const response = await api.get('/version');
    return response.data;
  } catch (error) {
    console.error('Failed to check version:', error);
    return null;
  }
}; 